import React, { useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'

interface SubmitPredictionsModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  inspectCount: number
  acceptedCount: number
  rejectedCount: number
}

const SubmitPredictionsModal: React.FC<SubmitPredictionsModalProps> = ({
  show,
  onHide,
  onConfirm,
  inspectCount,
  acceptedCount,
  rejectedCount,
}) => {
  const totalAccepted = inspectCount + acceptedCount
  const modalRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!show || !modalRef.current) return
    const node = modalRef.current
    const handleKeyDown = (e: KeyboardEvent) => {
      const key = e.key
      if (key === 'Escape') {
        e.preventDefault()
        e.stopPropagation()
        onHide()
        return
      }
      if (key === 'Enter') {
        // If a focusable control inside the modal is active, let the default click happen
        const active = document.activeElement as HTMLElement | null
        const isFocusableTag = (el: HTMLElement | null) => {
          if (!el) return false
          const tag = el.tagName
          return (
            tag === 'BUTTON' ||
            tag === 'A' ||
            tag === 'INPUT' ||
            tag === 'TEXTAREA' ||
            tag === 'SELECT'
          )
        }
        const activeInsideModal = !!active && node.contains(active)
        if (activeInsideModal && isFocusableTag(active)) {
          return
        }
        e.preventDefault()
        e.stopPropagation()
        onConfirm()
      }
    }
    document.addEventListener('keydown', handleKeyDown, true)
    return () => document.removeEventListener('keydown', handleKeyDown, true)
  }, [show, onHide, onConfirm])

  return (
    <Modal show={show} onHide={onHide} centered keyboard={false} backdrop="static">
      <div
        ref={modalRef}
        onKeyDownCapture={(e) => {
          if (e.key === 'Tab') {
            e.stopPropagation()
          }
        }}
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>Submit Predictions</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          <p>Confirm that you want to submit the predictions.</p>
          <p>Predictions in the Inspect tab will be submitted as accepted.</p>
          <p>Inspect tab: {inspectCount}</p>
          <p>Accepted tab: {acceptedCount}</p>
          <p>Rejected tab: {rejectedCount}</p>
          <p>Total accepted predictions: {totalAccepted}</p>
        </Modal.Body>
        <Modal.Footer className="bg-dark border-secondary">
          <Button variant="secondary" onClick={onHide}>
            Cancel (Esc)
          </Button>
          <Button variant="primary" onClick={onConfirm} autoFocus>
            Submit and Continue (Enter)
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

export default SubmitPredictionsModal
